__turbopack_context__.v({
  "affix": "V-lViG_affix",
  "border--none": "V-lViG_border--none",
  "borderColor--warning": "V-lViG_borderColor--warning",
  "colorScheme--muted": "V-lViG_colorScheme--muted",
  "colorScheme--none": "V-lViG_colorScheme--none",
  "container": "V-lViG_container",
  "field": "V-lViG_field",
  "hasLabel": "V-lViG_hasLabel",
  "input": "V-lViG_input",
  "isEmpty": "V-lViG_isEmpty",
  "label": "V-lViG_label",
  "size--lg": "V-lViG_size--lg",
  "size--sm": "V-lViG_size--sm",
  "width--maxcontent": "V-lViG_width--maxcontent",
  "wiggle--a": "V-lViG_wiggle--a",
  "wiggle--b": "V-lViG_wiggle--b",
});
